import API from 'API/index'
import {enqueueSnackbar as enqueueSnackbarAction} from 'store/actions/notifier'
import * as typeNotifier from 'shared/typeNotifications'
import * as informationMessages from 'constants/infoMessages'

export const START_LOAD_SHIFT_TRANSFER_HISTORY = 'START_LOAD_SHIFT_TRANSFER_HISTORY'
export const SUCCESS_LOAD_SHIFT_TRANSFER_HISTORY = 'SUCCESS_LOAD_SHIFT_TRANSFER_HISTORY'
export const ERROR_LOAD_SHIFT_TRANSFER_HISTORY = 'ERROR_LOAD_SHIFT_TRANSFER_HISTORY'

export const DATE_CHANGE_FILTER_STH = 'DATE_CHANGE_FILTER_STH'
export const MULTI_SELECT_CHANGE_FILTER_STH = 'MULTI_SELECT_CHANGE_FILTER_STH'
export const APPLY_FILTER_STH = 'APPLY_FILTER_STH'
export const CLEAR_FILTER_STH = 'CLEAR_FILTER_STH'
export const SET_PAGINATION_STH = 'SET_PAGINATION_STH'
export const SET_SORTING_STH = 'SET_SORTING_STH'

export const START_LOAD_FILTER_OPTIONS_STH = 'START_LOAD_FILTER_OPTIONS_STH'
export const SUCCESS_LOAD_FILTER_OPTIONS_STH = 'SUCCESS_LOAD_FILTER_OPTIONS_STH'
export const ERROR_LOAD_FILTER_OPTIONS_STH = 'ERROR_LOAD_FILTER_OPTIONS_STH'

export const GET_SHIFT_TRANSFER_HISTORY_DETAIL_START = 'GET_SHIFT_TRANSFER_HISTORY_DETAIL_START'
export const GET_SHIFT_TRANSFER_HISTORY_DETAIL_SUCCESS = 'GET_SHIFT_TRANSFER_HISTORY_DETAIL_SUCCESS'
export const GET_SHIFT_TRANSFER_HISTORY_DETAIL_ERROR = 'GET_SHIFT_TRANSFER_HISTORY_DETAIL_ERROR'

export const getShiftTransferHistory = (t, dto) => dispatch => {
  dispatch({type: START_LOAD_SHIFT_TRANSFER_HISTORY})
  API.getShiftTransferHistoryTable(dto)
    .then(({data}) => {
      dispatch({type: SUCCESS_LOAD_SHIFT_TRANSFER_HISTORY, data})
    })
    .catch(() => {
      dispatch({type: ERROR_LOAD_SHIFT_TRANSFER_HISTORY})
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_LOADING_ERROR}`),
          options: {variant: typeNotifier.ERROR},
        }),
      )
    })
}

export const getSTHFilterOptions = t => dispatch => {
  API.getShiftTransferHistoryFilterOptions()
    .then(({data}) => {
      dispatch({type: SUCCESS_LOAD_FILTER_OPTIONS_STH, data})
    })
    .catch(() => {
      dispatch({type: ERROR_LOAD_FILTER_OPTIONS_STH})
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_LOADING_ERROR}`),
          options: {variant: typeNotifier.ERROR},
        }),
      )
    })
}

export const getShiftTransferHistoryDetail = (id, t) => async dispatch => {
  try {
    dispatch({type: GET_SHIFT_TRANSFER_HISTORY_DETAIL_START})
    const {data} = await API.getShiftTransferHistoryById(id)
    dispatch({type: GET_SHIFT_TRANSFER_HISTORY_DETAIL_SUCCESS, payload: data})
  } catch (e) {
    dispatch({type: GET_SHIFT_TRANSFER_HISTORY_DETAIL_ERROR})
    dispatch(
      enqueueSnackbarAction({
        message: t(`infoMessages:${informationMessages.DATA_LOADING_ERROR}`),
        options: {variant: typeNotifier.ERROR},
      }),
    )
  }
}
